(function($) {

$(document).ready(function(){
	if ($('.faq').length) {
		$('.faq__item__head').on('click',function(){
			var item = $(this).parent();
			if (item.hasClass('open')) {
				item.removeClass('open');
				item.find('.faq__item__body').slideUp();
			} else {
				item.addClass('open');
				item.find('.faq__item__body').slideDown();
			}
		});
	}
});

})( jQuery );  